import { openDB } from 'idb';

const NOMBRE = 'hueco-db';
const VERSION = 2;

let dbp;
export function db() {
  if (!dbp) {
    dbp = openDB(NOMBRE, VERSION, {
      upgrade(d) {
        if (!d.objectStoreNames.contains('pendientes')) {
          d.createObjectStore('pendientes', { keyPath: 'client_uuid' });
        }
        if (!d.objectStoreNames.contains('catalogo')) {
          d.createObjectStore('catalogo', { keyPath: 'clave' });
        }
        if (!d.objectStoreNames.contains('sync_meta')) {
          d.createObjectStore('sync_meta', { keyPath: 'clave' });
        }
      },
    });
  }
  return dbp;
}

// --- Cola offline (solo IndexedDB, nunca localStorage para datos de negocio) ---
export async function encolar(mov) {
  const d = await db();
  await d.put('pendientes', {
    ...mov,
    estado: mov.estado || 'pendiente',
    intentos: mov.intentos || 0,
    creado_at: mov.creado_at || new Date().toISOString(),
  });
}

export async function listarPendientes() {
  const d = await db();
  return (await d.getAll('pendientes')).sort((a, b) => a.creado_at.localeCompare(b.creado_at));
}

export async function actualizarPendiente(client_uuid, cambios) {
  const d = await db();
  const actual = await d.get('pendientes', client_uuid);
  if (actual) await d.put('pendientes', { ...actual, ...cambios });
}

export async function borrarPendiente(client_uuid) {
  const d = await db();
  await d.delete('pendientes', client_uuid);
}

export async function contarPendientes() {
  const d = await db();
  return d.count('pendientes');
}

// --- Cache de catalogo para escanear sin red ---
export async function cachearCatalogo(clave, datos) {
  const d = await db();
  await d.put('catalogo', { clave, datos, ts: Date.now() });
}

export async function leerCatalogo(clave) {
  const d = await db();
  const r = await d.get('catalogo', clave);
  return r ? r.datos : null;
}

// Merge incremental: combina filas nuevas con lo cacheado usando una clave estable.
export async function mergeCatalogo(clave, nuevos, keyOf) {
  const d = await db();
  const prev = await d.get('catalogo', clave);
  const map = new Map();
  (prev?.datos || []).forEach((x) => map.set(keyOf(x), x));
  (nuevos || []).forEach((x) => map.set(keyOf(x), x));
  await d.put('catalogo', { clave, datos: [...map.values()], ts: Date.now() });
}

// Vacía el catálogo cacheado y las marcas de sincronización (al cambiar de tenant o cerrar sesión).
// La caché de catálogo es global (una sola copia); ligarla al tenant activo evita mostrar datos de otra empresa.
export async function limpiarCatalogo() {
  const d = await db();
  await d.clear('catalogo');
  await d.clear('sync_meta');
}

// Marca de agua (updated_at más alto ya sincronizado) por tabla, para pedir solo lo nuevo.
export async function getSyncMeta(clave) {
  const d = await db();
  const r = await d.get('sync_meta', clave);
  return r?.since || null;
}
export async function setSyncMeta(clave, since) {
  const d = await db();
  await d.put('sync_meta', { clave, since });
}

// Fecha (ms) del catálogo cacheado más reciente, para mostrarla en pantalla.
export async function catalogoActualizado() {
  const d = await db();
  let max = 0;
  for (const c of ['ubicaciones', 'articulos', 'stock', 'lpn', 'almacenes', 'zonas']) {
    const r = await d.get('catalogo', c);
    if (r?.ts) max = Math.max(max, r.ts);
  }
  return max || null;
}
